import React from 'react';
import randomstring from 'uuid/v4';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import User from './User';

const pagination = 15;

function getSurnameFormat(name) {
    return name ? name.replace(',', '').trim() : '';
}


class ListEmployees extends React.Component {

    state = {
        index: 0,
        employees: []
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    }

    static getDerivedStateFromProps(props, state) {

        const { employees, local } = props;
        if ( employees !== state.employees || local !== state.local ) {
            state.employees = employees;
            state.local = local;
            state.index = 0;
            console.log(employees);
            return state;
        }
        return null;

    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleClick = (event) => {
        this.setState({ index: this.state.index + pagination });
    };

    render() {
        const { employees } = this.state;
        const { employees_is_loading, employees_has_errored } = this.props;
        const data =  employees
                        .sort((a, b) =>
                            a.nombre.toUpperCase().trim() + ' ' + getSurnameFormat(a.apellidos).toUpperCase() <
                            b.nombre.toUpperCase().trim() + ' ' + getSurnameFormat(b.apellidos).toUpperCase()
                                ? -1
                                : 1,
                        );
            
        console.log('List', data);
        if (employees_has_errored.hasErrored) {
            return <Error open type={employees_has_errored.hasErrored}  message={employees_has_errored.error} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_column padding_bottom_9 padding_top_12 height100'}>
                    {employees_is_loading && <Loading open opacity />}
                    <div className="flex_full overflow_y_scroll" onScroll={this.handleScroll}>
                        {data.map((e) => <User key={randomstring()} user={e} /> )}
                    </div>
                </div>
            );
        }
    }
}

export default ListEmployees;



// WEBPACK FOOTER //
// ./src/components/complex/manage/employees/List.js